import { describe, toast } from '@servicetim/ui/components';

/** Error toast from anything a mutation throws (problem+json aware). */
export function notifyError(error: unknown, title?: string): void {
  const view = describe(error);
  toast.error(title ?? view.title, {
    description: view.detail && view.detail !== view.title ? view.detail : undefined,
  });
}

export function notifySaved(message = 'Saved'): void {
  toast.success(message);
}
